export { default as AggregateRating } from './AggregateRating';
export { default as AggregateRatingContainer } from './AggregateRatingContainer';
